<div class="vig-navbar">
  @for (item of items; track $index) {
    @if (item.enabled !== false) {
      @if (item.divider) {
        <div class="vig-navbar--divider"></div>
      } @else {
        <ng-container *ngTemplateOutlet="buttonTemplate; context: { item: item }"></ng-container>
      }
    }
  }
</div>

<ng-template #buttonTemplate let-item="item">
  <div class="vig-navbar--item" [class.vig-navbar--item__active]="item.active" (click)="onItemClick(item)">
    <div>
      <i class="material-icons">{{ item.icon }}</i>
    </div>
    <div class="vig-navbar--item__label">{{ item.label }}</div>
  </div>
</ng-template>
